import { render } from "./CalendarWeeks.vue?vue&type=template&id=0ca896b6&scoped=true"
import script from "./CalendarWeeks.vue?vue&type=script&lang=js"
export * from "./CalendarWeeks.vue?vue&type=script&lang=js"

import "./CalendarWeeks.vue?vue&type=style&index=0&id=0ca896b6&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca896b6"]])

export default __exports__